import React, { useState } from 'react';
import { ShieldAlert, ChevronDown, ChevronUp } from 'lucide-react';

interface HealthDisclaimerProps {
  title: string;
  text: string;
}

export const HealthDisclaimer: React.FC<HealthDisclaimerProps> = ({ title, text }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="mb-6 border border-brand-700/30 bg-brand-900/10 rounded-xl overflow-hidden">
      <button
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-brand-900/20 transition-colors"
      >
        <ShieldAlert className="w-4 h-4 text-brand-400 flex-shrink-0" />
        <span className="text-xs font-semibold text-brand-300 uppercase tracking-wider flex-1">
          {title}
        </span>
        {open ? (
          <ChevronUp className="w-4 h-4 text-brand-400" />
        ) : (
          <ChevronDown className="w-4 h-4 text-brand-400" />
        )}
      </button>
      {open && (
        <div className="px-4 pb-4 pt-1">
          <p className="text-xs text-gray-400 leading-relaxed">{text}</p>
        </div>
      )}
    </div>
  );
};
